import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';
import { bulkDisallowPresentContent } from 'features/permissions/actions';

export function* bulkDisallowPresentContentSaga(
  action: ReturnType<typeof bulkDisallowPresentContent>
) {
  const { roles } = action.payload;

  logger
    .remote({ action: true, tier: 1 })
    .info(`The user bulk disallowed present content for roles=${roles.join(',')}`);

  yield call(SignalingSocket.send, {
    event: 'bulkDisallowPresentContent',
    data: { roles },
  });
}
